<template>
  <v-app>
    <v-app-bar app :color="this.$pgsHelper.uiConfig().mainColor" dark class="elevation-7">
      <v-toolbar-title>{{
        this.$pgsHelper.uiConfig().appName
      }}</v-toolbar-title>
      <!-- -->
    </v-app-bar>
    <ModuleHeader class="mt-16 mx-6">Balance Monedero</ModuleHeader>
    <v-row>
      <v-col cols="12" md="12">
        <div v-if="$route.params.type">
          <v-alert v-if="$route.params.type == 'comisiones'"  dense text type="info">
            <p v-if="$route.params.type == 'comisiones'" class="mx-4"><b>Comisiones: Se pagarán al finalizar el mes.
              Solicítalas por WhatsApp al <a href="https://api.whatsapp.com/send?phone=5219981499141"
                target="_blank">9981499141</a></b></p>
          </v-alert>
          

        </div>
        <v-card v-if="cliente">
          <v-card-text>
            <v-card-title class="text-h5">{{
              cliente.NombreCompleto
            }}</v-card-title>
            <div class="mx-4 text-h6">
              Saldo Monedero : $
              {{ $pgsHelper.formatNumber(cliente.SaldoConversion) }}
            </div>
            <v-divider></v-divider>
            <div class="mx-4 mt-4 text-subtitle-1">
              Movimientos
            </div>
            <v-simple-table fixed-header class="monederosTable">
              <thead>
                <tr>
                  <th>Movimiento</th>
                  <th>Cantidad</th>
                  <th>Cantidad {{ $Currencies.getCurrencyDefault() }}</th>
                  <th>Saldo Desp. Mov.</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(producto, index) in movimientos">
                  <tr :key="index">
                    <td>
                      {{ producto.Descripcion }}<br />{{ producto.Fecha }}<br />
                      <b v-if="producto._m">{{ producto._m.og }}</b>
                    </td>

                    <td>{{ producto.Cantidad }} p</td>
                    <td>{{ producto.Cantidad * 1 }} {{ $Currencies.getCurrencyDefault() }}</td>
                    <td>
                      Antes:<b>{{
                        $pgsHelper.formatNumber(producto.SaldoAnterior)
                      }}</b><br />
                      Despues :<b>
                        {{
                          $pgsHelper.formatNumber(producto.SaldoPosterior)
                        }}</b>
                    </td>
                    <td>
                      <i v-if="producto._Op == 'R'" style="font-size: 20px; color: red"
                        class="lni lni-arrow-down-circle"></i>
                      <i v-if="producto._Op == 'D'" style="font-size: 20px; color: green"
                        class="lni lni-arrow-up-circle"></i>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import Cliente from "../../../clases/Cliente.js";
export default {
  name: "MonederoBalanceClient",
  components: {},
  props: [],
  data() {
    return {
      cliente: null,
      movimientos: [],
    };
  },
  methods: {
    getData(idCliente, Tenant) {
      this.$store.getters.getFirebaseApp.fba
        .call(
          "PDV-Monederos-getMonedero?clienteId=" + idCliente,
          {
            clienteId: idCliente,
            tenant: Tenant,
          },
          {
            "PGS-REQ-APP": "-O1raxDiPYgvyxUHnrt0",
            "PGS-REQ-VERSION": "1",
          }
        )
        .then((result) => {
          if (result.data.ok) {
            let cliente = result.data.data.cliente;
            cliente.SaldoConversion = result.data.data.saldo * 1;
            cliente.NombreCompleto = cliente.Nombres + " " + cliente.Apellidos;
            this.cliente = cliente;
            this.getMovimientosMonedero(result.data.data.movimientos);
          }
        })
        .catch((error) => {
          this.$swal.showValidationMessage(`Request failed: ${error}`);
        });
    },
    async getMovimientosMonedero(movimientosArray) {
      let movimientos = [];
      let withoutInitialcharge = movimientosArray.filter((mov) => mov.Descripcion != 'Creacion Monedero')
      withoutInitialcharge.forEach((mov, index) => {
        mov.Cliente = "";
        mov.Index = Number(index);
        movimientos.push(mov);
      });

      let orderMovs = this.$_.orderBy(
        movimientos,
        ["Fecha", "Index"],
        ["asc", "asc"]
      );
      let saldoAnterior = 0;

      orderMovs.forEach((mov) => {
        mov.SaldoAnterior = saldoAnterior;
        if (mov._Op == "D") {
          saldoAnterior = saldoAnterior + mov.Cantidad;
        } else {
          saldoAnterior = saldoAnterior - mov.Cantidad;
        }
        mov.SaldoPosterior = saldoAnterior;
      });
      //this.movimientos = orderMovs
      this.movimientos = this.$_.orderBy(
        orderMovs,
        ["Fecha", "Index"],
        ["desc", "desc"]
      );
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () { },
  mounted() {
    if (this.$route.params.idCliente) {
      this.getData(this.$route.params.idCliente, this.$route.params.TENANT);
      //this.getClientData(this.$route.params.idCliente);
    }
  },
};
</script>
<style>
.monederosTable table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

.monederosTable table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}

.monederosTable table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}

.monederosTable table th,
.monederosTable table td {
  padding: 0.625em;
  text-align: center;
  padding: 12px !important;
}

.monederosTable table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

@media screen and (max-width: 600px) {
  .monederosTable table {
    border: 0;
  }

  .monederosTable table caption {
    font-size: 1.3em;
  }

  .monederosTable table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .monederosTable table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
    display: grid;
  }

  .monederosTable table td {
    display: table-row;
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: center;
    height: auto !important;
    width: 100% !important;
    padding: 15px !important;
  }

  .monederosTable table td .v-card {
    height: 74px;
    min-width: 78px;
    padding: 0 19.5555555556px;
    margin-top: 25px;
  }

  .monederosTable table td:last-child {
    border-bottom: 0;
  }
}
</style>
